const validatePhone = phone => {
  if (!phone) {
    return false;
  }

  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 11) {
    return false;
  }

  const trimmedPhone = phone.replace(/\s/g, '');

  return /^\+?[\d-]+$/.test(trimmedPhone) || /^\+?\d*\(\d+\)[\d-]+$/.test(trimmedPhone);
};

export default validatePhone;
